import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z7() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div className={`d2x-Z7 ${css.d2xZ7} GtmModuleData-section`} data-section-id={css.d2xZ7} data-section-title={t('sec7_title')}>
            <div className="sec7">
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z7.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z7.jpg')}
                        alt={t('sec7_title')}
                        aria-label={t('sec7_title')}
                    />
                </div>
                <div className="text-box">
                    <p className="title">{t('sec7_title')}</p>
                    <p className="desc">{t('sec7_desc')}</p>
                </div>
            </div>
        </div>
    );
}
